import styled from 'styled-components';
import { CssRule } from '../../../themes/architecture/css-helpers/css-rule';

export const IdleRecommendationHeaderBox = styled.div`
    padding-bottom: 10px;
    letter-spacing: 0.8px;
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        ${CssRule.For.iPhoneVer5.build()} {
            font-size: 1rem;
        }
    }
`;